export default {
  "nl": {
    "timestamp": {
      "labels": {
        "accepted": "Aanvaard op {date}",
        "due": "Deadline: {date}",
        "in": "Binnen {time}",
        "justNow": "Zonet",
        "noDeadline": "Geen deadline",
        "starts": "Start: {date}",
        "today": "Vandaag",
        "tomorrow": "Morgen",
        "uploaded": "Geüpload op {date}",
        "yesterday": "Gisteren"
      }
    }
  }
}